import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import SubHeader from '../../components/Subheader/Subheader';
import CustomBreadcrumbs from '../../components/Tools/Breadcumbs';
import MainFilter from '../../components/Tools/MainFilter';
import DashboardFilter from '../Dashboard/components/DashboardFilter';
import Spinner from '../../components/Tools/spinner';
import SmetReportList from '../../components/Reports/SmetReportList';
import { getSmetReports } from '../../helper/Api';

const emptyFilter = {
    searchStr: '',
    fromDate: '',
    toDate: '',
    dateColumn: '',
    department_id: '',
    parent_department_id: '',
    tier: '',
    consolidate: false,
    district_id: '',
    district_name: '',
};

const SmetChallanReport = () => {
    const { financialYears } = useSelector((state) => state.authData);
    const fyList = financialYears?.payload?.fy_list || [];
    const [fyId, setFyId] = useState(() => localStorage.getItem('globalDateId') || '');
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [open, setOpen] = useState(false);
    const [amountTick, setAmountTick] = useState(0);
    const [filterPayload, setFilterPayload] = useState(emptyFilter);
    const [filterApplied, setFilterApplied] = useState(emptyFilter);

    const handleInput = (event) => {
        const { name, value } = event.target;
        setFilterPayload((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const applyFilter = () => {
        setFilterApplied(filterPayload);
        setOpen(false);
    };

    const handleFilterRemove = (name) => {
        const cleared = (name === 'fromDate' || name === 'toDate')
            ? { fromDate: '', toDate: '' }
            : name === 'district_id'
                ? { district_id: '', district_name: '' }
                : name === 'parent_department_id'
                    ? { parent_department_id: '', parent_department_name: '' }
                    : { [name]: '' };
        const next = { ...filterPayload, ...cleared };
        setFilterPayload(next);
        setFilterApplied(next);
    };

    const handlePageTrigger = () => {
        setFyId(localStorage.getItem('globalDateId') || '');
    };

    useEffect(() => {
        const onAmountDivisorChange = () => setAmountTick((tick) => tick + 1);
        window.addEventListener('amount_divisor_changed', onAmountDivisorChange);
        return () => window.removeEventListener('amount_divisor_changed', onAmountDivisorChange);
    }, []);

    useEffect(() => {
        let cancelled = false;
        const load = async () => {
            setLoading(true);
            try {
                const resp = await getSmetReports({
                    from_date: filterApplied.fromDate || '',
                    to_date: filterApplied.toDate || '',
                    search_str: filterApplied.searchStr || '',
                    fy_id: fyId || localStorage.getItem('globalDateId') || '',
                    department_id: filterApplied.department_id || '',
                    parent_department_id: filterApplied.parent_department_id || '',
                    district_id: filterApplied.district_id || '',
                });
                if (!cancelled) {
                    setData(resp?.data?.status ? (resp.data.list || []) : []);
                }
            } catch (error) {
                if (!cancelled) setData([]);
            } finally {
                if (!cancelled) setLoading(false);
            }
        };
        load();
        return () => {
            cancelled = true;
        };
    }, [fyId, filterApplied]);

    return (
        <div>
            {loading && <Spinner />}
            <SubHeader fy_list={fyList} handlePageTrigger={handlePageTrigger} />
            <div className="scheme p-2">
                <div className="row" style={{ padding: '10px 16px' }}>
                    <div className="col-md-6">
                        <h4 style={{ color: '#28326f', margin: 0 }}>SMET Report</h4>
                        <CustomBreadcrumbs linksArray={[]} title="SMET Report" />
                    </div>
                </div>
                <DashboardFilter
                    openFilterModal={setOpen}
                    filterPayload={filterApplied}
                    handleFilterRemove={handleFilterRemove}
                    isTierRemovalRequired
                />
                <SmetReportList data={data} amountTick={amountTick} />
                <MainFilter
                    open={open}
                    handleClose={() => setOpen(false)}
                    handleInput={handleInput}
                    handleOpen={() => setOpen(true)}
                    handleFilterClick={applyFilter}
                    filterPayload={filterPayload}
                    setConsolidate={setFilterPayload}
                    type="SMET Report"
                />
            </div>
        </div>
    );
};

export default SmetChallanReport;
